import { FC } from 'react'

import { Card, CardContent, CardFooter, Cluster, Grid, Separator, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'

export const ShipmentDetailTitleSkeleton: FC = () => {
  return (
    <Cluster gap={8} y="center" fullWidth>
      <Skeleton variant="icon" />
      <Stack gap={4} fullWidth>
        <Grid col={8}>
          <Skeleton variant="badge" fullWidth />
        </Grid>
        <Skeleton variant="content" />
      </Stack>
    </Cluster>
  )
}

const ShipmentDetailSidebarSkeleton: FC = () => {
  return (
    <Stack gap={16}>
      {Array.from({ length: 6 }).map((_, index) => (
        <Cluster key={index} gap={8} y="baseline">
          <Skeleton variant="icon" />
          <Skeleton variant="button" fullWidth />
        </Cluster>
      ))}
    </Stack>
  )
}

const ShipmentDetailMainSkeleton: FC = () => {
  return (
    <Stack gap={24}>
      <Card>
        <CardContent>
          <Stack gap={16}>
            <Stack gap={16}>
              <Grid col={4}>
                <Skeleton variant="badge" fullWidth />
              </Grid>
              <Grid col={5}>
                <Skeleton variant="content" fullWidth />
              </Grid>
              <Grid col={7} gap={24}>
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
              </Grid>
            </Stack>

            <Grid col={7} gap={24}>
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
            </Grid>
            <Separator orientation="horizontal" />
            <Grid col={5}>
              <Skeleton variant="content" fullWidth />
            </Grid>
            <Grid col={7} gap={24}>
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
            </Grid>
          </Stack>
        </CardContent>
        <CardFooter>
          <Skeleton variant="button" />
        </CardFooter>
      </Card>
      <Grid col={2} gap={24}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Card key={index}>
            <CardContent>
              <Stack gap={16}>
                <Skeleton variant="badge" />
                <Skeleton variant="content" size={12} fullWidth />
                <Grid col={2}>
                  <Skeleton variant="button" fullWidth />
                </Grid>
                <Grid col={4}>
                  <Skeleton variant="button" fullWidth />
                </Grid>
                <Grid col={3}>
                  <Skeleton variant="button" fullWidth />
                </Grid>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Grid>
    </Stack>
  )
}

export const ShipmentDetailsSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<ShipmentDetailTitleSkeleton />}
      hideTitleBackgroundImage
      sidebar={<ShipmentDetailSidebarSkeleton />}
      navigation={<Back to="/" />}
      main={<ShipmentDetailMainSkeleton />}
      footer={<Footer />}
    />
  )
}
